import React from 'react'
import './footer.css'
import '../../App.css'
const Footer = () => {
  return (
    <>
    <div className="footer">
    <p>
            Designed by <a href="https://www.linkedin.com/in/reboot13/?originalSubdomain=in" target="_blank">&nbsp;Krutik Raut&nbsp;</a> and Coded with ❤ by <a href="https://www.linkedin.com/in/christ-tailor-00a5301ba/" target="_blank">&nbsp;Christ Tailor</a>
        </p>
    </div>

    </>
  )
}

export default Footer
